import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import profileApi from '../../api/profileApi';

/* -------------------------- FETCH MY PROFILE -------------------------- */
export const fetchMyProfile = createAsyncThunk(
  'profile/fetchMyProfile',
  async (_, { rejectWithValue }) => {
    try {
      const profile = await profileApi.getMyProfile();
      return { profile, securityAnswers: [] }; // securityAnswers not needed here
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.detail || 'Failed to load profile'
      );
    }
  }
);

/* -------------------------- CHANGE PASSWORD THUNK -------------------------- */
export const changePassword = createAsyncThunk(
  'profile/changePassword',
  async (payload, { rejectWithValue }) => {
    try {
      await profileApi.changePassword(payload);
      return true;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.detail ||
          err.response?.data?.old_password?.[0] ||
          err.response?.data?.new_password?.[0] ||
          'Password change failed'
      );
    }
  }
);

const initialState = {
  profile: null,
  securityAnswers: [],
  isLoading: false,
  error: null,
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    updateProfile: (state, action) => {
      state.profile = { ...state.profile, ...action.payload };
    },
    updateSecurityAnswers: (state, action) => {
      const updatedMap = {};
      action.payload.forEach((item) => {
        updatedMap[item.id] = item;
      });
      state.securityAnswers = state.securityAnswers.map((old) =>
        updatedMap[old.id] ? { ...old, ...updatedMap[old.id] } : old
      );
    },
  },
  extraReducers: (builder) => {
    // fetchMyProfile
    builder
      .addCase(fetchMyProfile.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchMyProfile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.profile = action.payload.profile;
        state.securityAnswers = action.payload.securityAnswers;
      })
      .addCase(fetchMyProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // changePassword
    builder
      .addCase(changePassword.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(changePassword.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const {
  clearError,
  updateProfile,
  updateSecurityAnswers,
} = profileSlice.actions;

export default profileSlice.reducer;